<div class="modal-success">
  <div class="image-container">
    <img
      *ngIf="status === 'ACCEPTED'"
      src="../../../assets/img/create_rdv_modal.png"
      alt="package image"
    />
    <img
      *ngIf="status === 'REFUSED'"
      src="../../../assets/img/rdv_refused.svg"
      alt="package image"
    />
    <img
      class="valide-tick"
      *ngIf="status === 'ACCEPTED'"
      src="../../../assets/icon/valide-tick.svg"
      alt="valid tick"
    />
  </div>
  <p>
    {{ messageText | translate }}
  </p>
  <div class="buttons-group">
    <app-button
      [styles]="{ maxHeight: '40px',paddingInline: '15px' }"
      [innerText]="buttonText | translate"
      (onClick)="handleValidBtnClick()"
    >
    </app-button>

    <app-button
      [styles]="{ backgroundColor: '#88a8c7', maxHeight: '40px',paddingInline: '15px',width: '100%' }"
      [innerText]="'RDV_PAGE.REFUSED_CACENLE_BUTTON' | translate"
      (onClick)="cancleDemand()"
      [loading]="isLoading"
      [disabled]="isLoading"
    >
    </app-button>
  </div>
</div>
